import React, { useEffect, useState, useContext } from "react";
import ListAndAddTabs from "components/Layout/ListAndAddTabs";
import Page from "components/Page";
import GuardsTable from "Modules/Guards/GuardsTable";
import { AuthContext } from "Firebase/AuthProvider";

interface GuardsState {
  editing: boolean;
  tabValue: number;
}

const DEFAULT_STATE: GuardsState = {
  editing: false,
  tabValue: 0,
};

export default function Guards() {
  const [state, setState] = useState(DEFAULT_STATE);
  const list: JSX.Element = <GuardsTable />;
  const add: JSX.Element = <div>add</div>;
  const { setRoute } = useContext(AuthContext);
  useEffect(() => {
    setRoute("Guards");
  }, []);
  const handleTabChange = (newValue: number) => {
    setState({ ...state, tabValue: newValue });
  };

  return (
    <Page title="Guards">
      <ListAndAddTabs
        value={state.tabValue}
        handleChange={handleTabChange}
        listChildren={list}
        addChildren={add}
        fromEdit={state.editing}
      />
    </Page>
  );
}
